<template>
  <delivery-team-shell v-if="useNewView" @legacy="openLegacy" />
  <users-legacy v-else @new-view="openNewView" />
</template>

<script>
import UsersLegacy from "./UsersLegacy.vue";
import DeliveryTeamShell from "@/components/delivery-team-shell/DeliveryTeamShell.vue";
import { LEGACY_UI_VALUE, TEAM_QUERY } from "@/components/delivery-team-shell/teamQuery";
import deliveryUsersContext from "@/mixins/deliveryUsersContext";

/**
 * Korisnici (firma, restoran, dostavna firma). Dostavna firma (/firma-dostava/:id/korisnici) ima novi izgled kao izvještaji,
 * magacin, recepti i finansije; ?ui=stari vraća staru stranicu. Korisnici običnih firmi i restorana ostaju na staroj stranici,
 * jer imaju kredit, ograničenje i izvještaje koje dostava nema.
 */
export default {
  name: "Users",
  components: { UsersLegacy, DeliveryTeamShell },
  mixins: [deliveryUsersContext],
  computed: {
    useNewView() {
      return this.isDeliveryUsersContext && this.$route.query[TEAM_QUERY.legacy] !== LEGACY_UI_VALUE;
    },
  },
  methods: {
    openLegacy() {
      this.$router.replace({ query: { ...this.$route.query, [TEAM_QUERY.legacy]: LEGACY_UI_VALUE } }).catch(() => {});
    },
    openNewView() {
      const query = { ...this.$route.query };
      delete query[TEAM_QUERY.legacy];
      this.$router.replace({ query }).catch(() => {});
    },
  },
};
</script>
